import { Box } from "@mui/system";

type DividerProps = {
    keyId?: string,
    orientation: string
}

const ToolbarDivider = (props: DividerProps) => {
    const renderDivider = () => {
        if (props.orientation === 'horizontal') {
            return (
                <Box key={props.keyId} sx={{ bgcolor: '#D6D6D6', width: '1px', height: '100%', mx: 1 }} />
            )
        } else {
            return (
                <Box key={props.keyId} sx={{ bgcolor: '#D6D6D6', width: '100%', height: '1px', my: 1 }} />
            )
        }
    }

    return (
        <>
            {renderDivider()}
        </>
    )
}

export default ToolbarDivider;